import revive_payload_client_YTGlmQWWT5 from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_PKIXU5KmsI from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_LIYcCMJD18 from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_SeG0EjL5Ec from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_xKuw1km5sV from "/codebuild/output/src3264125088/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/codebuild/output/src3264125088/src/packages/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "/codebuild/output/src3264125088/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/codebuild/output/src3264125088/src/packages/frontend/.nuxt/pwa-icons-plugin.ts";
import pwa_client_V4UTG2qgGR from "/codebuild/output/src3264125088/src/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import switch_locale_path_ssr_lCxu0ZmxIx from "/codebuild/output/src3264125088/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_6xSY8Eag1D from "/codebuild/output/src3264125088/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_5C7QFp7tsq from "/codebuild/output/src3264125088/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import apexcharts_VxzzcHGhhi from "/codebuild/output/src3264125088/src/packages/frontend/plugins/apexcharts.ts";
import clickOutside_C8jIyDRU4O from "/codebuild/output/src3264125088/src/packages/frontend/plugins/clickOutside.js";
import sentry_3AyO8nEfhE from "/codebuild/output/src3264125088/src/packages/frontend/plugins/sentry.ts";
import trpc_0KeCZOBKLF from "/codebuild/output/src3264125088/src/packages/frontend/plugins/trpc.ts";
import ssg_detect_O3dFMwF5H0 from "/codebuild/output/src3264125088/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  navigation_repaint_client_PKIXU5KmsI,
  check_outdated_build_client_LIYcCMJD18,
  chunk_reload_client_SeG0EjL5Ec,
  plugin_vue3_xKuw1km5sV,
  components_plugin_KR1HBZs4kY,
  prefetch_client_8FoqvPFTot,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_V4UTG2qgGR,
  switch_locale_path_ssr_lCxu0ZmxIx,
  route_locale_detect_6xSY8Eag1D,
  i18n_5C7QFp7tsq,
  apexcharts_VxzzcHGhhi,
  clickOutside_C8jIyDRU4O,
  sentry_3AyO8nEfhE,
  trpc_0KeCZOBKLF,
  ssg_detect_O3dFMwF5H0
]